import { styled } from "../../stitches.config";
import { Box } from "../primitives";

export const StrategyCardContainer = styled(Box, {
  borderRadius: "12px",
  padding: "24px",
  backgroundColor: "#fff",
  position: "relative",
  cursor: "pointer",
  width: "100%",
  maxWidth: 400,
  variants: {
    isSelected: {
      true: {
        boxShadow: "0 0 8px 3px #166534",
        border: "1px solid #166534",
      },
      false: {
        boxShadow: "0 4px 4px rgba(0,0,0,0.4)",
        border: "1px solid #ddd",
      },
    },
  },
});
